import React from "react";

function ChoicesGroupLabel(props:{label: string, required?: boolean})
{
    return <p style={{lineHeight:'1.5em',marginBottom:'0.75em'}}>
        {props.label}
        {props.required && <span className="text-primary">*</span>}
    </p>
}

export default ChoicesGroupLabel;